export enum Operation {
    LOAD_CONFIG = 'loadConfig',
    PLAY = 'play',
    STATS = 'stats',
}
